import M from 'materialize-css'

export const validateCostField = (e) => {
    const { value } = e.target;

    if (isNaN(value)) {
        M.toast({html: 'Numerical values only!'})
    }
}